import EventEmitter from 'tiny-emitter'
import Hammer from 'hammerjs'

export default class AbstractCarrousel extends EventEmitter {
  constructor( options = {} ){
    super()
    
    this.loop = options.loop || false
    this.swipe = options.swipe || false
    this.drag = options.drag || false

    this.position = 0
    this.total = 1
    this.direction = 1
    this.autoSpeed = 0.001

    this.position = 0

    if( window.innerWidth > 768 ){
      this.space = window.innerWidth * 0.4
    }else{
      this.space = window.innerWidth * 0.8
    }
    
  }

  start(){
    this.looop()
  }

  looop(){
    requestAnimationFrame(()=>this.looop())

    if( this._el.classList.contains('in-viewport') ){    
      this.position += this.autoSpeed * this.direction
      if( this.position > (this.total - 1) && this.direction == 1 ) this.direction = -1
      else if( this.position < 0 && this.direction == -1 ) this.direction = 1

      this._update(this.position)
    }
  }

  initTouch(){
    this.hammer = new Hammer(this._el);
    
    if( this.swipe ){
      this.hammer.on('swipe', (e)=>{
        if( e.deltaX > 0 ){
          this.next()
        }else{
          this.previous()
        }
      }) 
    }

    if( this.drag ){
      this.hammer.on('panstart', (e)=>{
        this.startPanPosition = this.position
        this.isPanning = true
      }).on('panmove', (e) => {
        let current
        if( this.toLeft ){
          current = this.startPanPosition + e.deltaX / this.space
        }else{
          current = this.startPanPosition - e.deltaX / this.space
        }
        this._update(this.clamp(current))
        e.preventDefault()
      })
      .on('panend', (e)=>{
        // this.el.classList.remove('grabbing')
        // let delta = e.deltaX + e.overallVelocityX * this.space

        let current
        if( this.toLeft ){
          current = this.startPanPosition + e.deltaX / this.space
        }else{
          current = this.startPanPosition - e.deltaX / this.space
        }
        
        // if( Math.round( this.current ) != Math.round( this.position ) ){
        //   this._round()
        // }else if( Math.abs(delta) > App.innerWidth * .05 ){
        //   if( delta < 0 ){
        //     this.next()
        //   }else{
        //     this.previous()
        //   }
        // }else{
        //   this._round()
        // }
        // setTimeout(()=>{ this.isPanning = false }, 100)
      })

    }
    
  }

  next(){
    let p = this.position + 1
    this.direction = 1
    if( p >= this.total ){
      if( this.loop ){
        p = 0
      }else{
        p = this.total - 1
      }
    }
    this.goto( p )
  }

  previous(){
    let p = this.position - 1
    this.direction = -1
    if( p < 0 ){
      if( this.loop ){
        p = this.total - 1
      }else{
        p = 0
      }
    }

    this.goto( p )
  }

  goto( to ){
    
    if( ! this.updating ){

      // to = this.clamp( to )

      if( this.position != to ){
        this.updating = true
        this._update(to, this.position)        
      } 
    }
  }

  clamp( to ){
    if( to < 0 ){
      to = 0
    }else if( to > this.total - 1 ){
      to = this.total - 1
    }
    return to
  }

  _update( to, current ){
    this.position = to
    this._updated()
  }
  _updated(){
    this.updating = false
  }
}